import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InfoPopoverComponent } from "./info-popover/info-popover.component";
@NgModule({
  imports: [CommonModule],
  declarations: [InfoPopoverComponent],
  exports: [InfoPopoverComponent],
})
export class InfoPopoverModule {}
